import { z } from 'zod';
import { Lifecycle } from './lifecycles.model';
import { sbefScopeGroupKeys } from '../construction/sbef-custom-groups.data';

/** Organization-owned, reusable snapshot of a calculation scope. */
export const createSavedScopeSchema = z.object({
  name: z.string().trim().min(1).max(80),
  lifecycles: z.array(z.enum(Lifecycle)).max(Object.keys(Lifecycle).length),
  sbefGroups: z
    .array(z.enum(sbefScopeGroupKeys))
    .max(sbefScopeGroupKeys.length),
  conservative: z.boolean(),
  calculationPeriodYears: z.number().int().positive().max(1000).optional(),
  target: z.number().finite().nonnegative().optional(),
});
export type CreateSavedScope = z.infer<typeof createSavedScopeSchema>;
export const savedScopeSchema = createSavedScopeSchema.extend({
  id: z.string().uuid(),
  deleted: z.boolean().optional(),
});
export type SavedScope = z.infer<typeof savedScopeSchema>;
